export default __webpack_public_path__ + "static/media/rocket.3f172cbb.png";